import { render, staticRenderFns } from "./business.vue?vue&type=template&id=38364cdf&scoped=true&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"
import style0 from "./business.vue?vue&type=style&index=0&id=38364cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38364cdf",
  null
  
)

export default component.exports